<template>
  <div class="location-container" ref="container">
    <div>
      <div class="content" :style="conHeight">
        <div class="contents">
          <el-row style="height:100%" :gutter='20'>
            <el-col :span="9" style="height:100%;padding-top:3vh;" >
              <el-card class="box-card">
                <div slot="header" class="clearfix">
                  <span>查询定位</span>
                </div>
                <el-row  justify='center'>
                  <el-form  :inline="true" label-width="70px">
                    <el-col :span="12">
                      <el-form-item label="姓名">
                        <el-input v-model="name" clearable placeholder="请输入姓名"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="手机号">
                        <el-input v-model="phone" maxlength="11" clearable placeholder="请输入手机号"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="身份证号">
                        <el-input v-model="idCard" maxlength="18" clearable placeholder="请输入身份证号"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12" style="text-align:center">
                      <el-button  type="primary" @click="getDevice" plain style="background: transparent;border-color: rgba(0, 236, 252, 1);color:rgba(0, 236, 252, 1)">搜索</el-button>
                    </el-col>
                  </el-form>
                </el-row>
                <template>
                  <el-table
                    :data="dataList"
                    stripe
                    style="width: 100%" height="550">
                    <el-table-column
                      prop="userName"
                      label="老人姓名">
                    </el-table-column>
                    <el-table-column
                      prop="phone"
                      label="手机号">
                    </el-table-column>
                    <el-table-column
                      prop="idCard"
                      label="身份证号">
                    </el-table-column>
                    <el-table-column label="操作" width="100" align='center'>
                          <template slot-scope="scope">
                              <el-button size="mini" type="primary" @click="handleInfo(scope.row)">选择</el-button>
                          </template>
                      </el-table-column>
                  </el-table>
                </template>
              </el-card>
            </el-col>
            <el-col :span="15" style="height:100%;padding-top:3vh;">
              <div class="top">
                <Daterange :startTime="startTime" :endTime="endTime" isDatetime='datetime'  @dataChange='dataChange' style="margin-right:10px"></Daterange>
                <el-button  type="primary" @click="getTrack" plain style="background: transparent;border-color: rgba(0, 236, 252, 1);color:rgba(0, 236, 252, 1)">查看运动轨迹</el-button>
                <el-button  type="primary" @click="getlocatiom" plain style="background: transparent;border-color: rgba(0, 236, 252, 1);color:rgba(0, 236, 252, 1)">定位</el-button>
              </div>

              <div class="serviceMap">
                <div class="elderlyInfo" v-if="elderlyData">
                  <el-row>
                    <el-col :span="12">
                      姓名：{{elderlyData.userName}}
                    </el-col>
                    <el-col :span="12">
                      手机号：{{elderlyData.phone}}
                    </el-col>
                  </el-row>
                </div>
                <!-- <div class="play" @click="reset" v-show="flash">
                  <div style="position: relative;">
                    <i class="el-icon-video-play" v-show='!play'></i>
                    <i class="el-icon-video-pause" v-show='play'></i>
                  </div>
                </div> -->
                <baidu-map :center="map.center"   @ready="handler" :mapClick="false" :mapStyle="mapStyle" :zoom="map.zoom" style="height:82vh;overflow:hidden;min-height:500px;margin-bottom:1.5vh" :scroll-wheel-zoom='true'>
                  <!-- <bm-map-type :map-types="['BMAP_NORMAL_MAP', 'BMAP_HYBRID_MAP']" anchor="BMAP_ANCHOR_BOTTOM_LEFT" :offset="bMapSize"></bm-map-type> -->
                  <bm-marker  :icon='icon'
                      :position="location" v-if="location">
                  </bm-marker>
                  <!-- <bm-polyline :path="locationList" stroke-color="rgba(29, 211, 138, 1)" :stroke-opacity="1" :stroke-weight="3"></bm-polyline> -->
                  <!-- <bml-lushu
                    @stop="reset1"
                    :path="locationList"
                    :speed='200'
                    :icon="icon"
                    :play="play">
                  </bml-lushu> -->
                </baidu-map>
              </div>

            </el-col>
          </el-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { BmlLushu } from 'vue-baidu-map'
// import 'element-ui/lib/theme-chalk/base.css';
import leftBox from "./img/leftBox.png"
import Daterange from "@/components/Daterange";
import styleJson from "@/common/custom_map_config.json"
import titleImg from "./img/titleImg.png"
import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getInsNameByDomainName, getToken} from '@/utils/auth'
export default {
  name: "Home",
  data() {
    return {
      plateFormList: [],
      govermentCodeList: [],
      play: false,
      flash: false,
      location:null,
      startTime:'',
      endTime:'',
      locationList:[],
      dataList:[],
      elderlyData:null,
      leftBox:leftBox,
      titleImg:titleImg,
      name:'',
      phone:'',
      idCard:'',
      times:'',
      dateValue:'',
      pickerOptionsStart: {
        disabledDate (time) {
          return time.getTime() < 1488297600000 || time.getTime() >= Date.now();
        }
      },
      icon: {
        url: require('./img/icon.png'),
        size: {width: 52, height: 45},
        // opts: {anchor: {width: 52, height:45}}
      },
      // icon:require('./img/icon.png'),
      pollNum:0,
      map:{
        center:{lng: 105.757523, lat: 34.167794},
        zoom:5,
      },
      ms:[],
      mapStyle:{
        styleJson:styleJson
      },
      conHeight: {
        height: ''
      },
      bMap:null,
      bMapSize:null,
      mapCan:null,
    }
  },
  mounted() {
    this.$nextTick(() => { // 页面渲染完成后的回调
      this.conHeight.height = this.$refs.container.offsetHeight - 90 + 'px'
    })
    for (let i = 0; i < 10; i++) {
      const position = { lng: Math.random() * 40 + 85, lat: Math.random() * 30 + 21, showFlag: false }
      this.ms.push(position)
    }
    this.init()
  },
  components: {
    // BmlLushu,
  Daterange},
  watch: {
    //监听全局变量
    '$store.state.tableHeight': function () {
      this.conHeight.height = this.$refs.container.offsetHeight - 90 + 'px'
    },
  },
  // created(){
  //    this.init()
  // },
  methods: {
    init() {
      this.$store.commit('update', ['title', getInsNameByDomainName()+'定位系统']);
      this.getDevice()
    },
    dataChange(val) {
      this.startTime = val[0]
      this.endTime = val[1]
    },
    handler({ BMap, map }){
      this.bMap=BMap
      this.mapCan=map
      this.bMapSize=new BMap.Size(20, 60)
      map.setMapStyleV2({
        styleId: '5c78974534ede0f3d27c313340264e0b'
      });
    },
    luxian(listLonLat){
      listLonLat=this.newArr(listLonLat)
      this.mapCan.enableScrollWheelZoom(true);
      let list=[]
      for(var i in listLonLat){
        list.push(new this.bMap.Point(listLonLat[i].lng,listLonLat[i].lat))
      }
      var walking = new this.bMap.WalkingRoute(this.mapCan, {renderOptions:{map: this.mapCan, autoViewport: true}});
      // var that=this
      // driving.setPolylinesSetCallback(function(result){
      // //清除路线规划
      //     driving.clearResults();
      //     var points = [];
      //     result[0].Pq.map(function(item){
      //       points.push(new that.bMap.Point(item.lng,item.lat))
      //     })
      //     var polyline = new that.bMap.Polyline(points, {strokeColor:"#438EFF", strokeWeight:5, strokeOpacity:0.5});   //创建折线
      //     that.mapCan.addOverlay(polyline);   //增加折线
      // })
      let list1=[]
      for(var j in list){
        if(j==0||j==list.length-1){
          continue
        }
        list1.push(list[j])
      }
      walking.search(list[0], list[list.length-1],{waypoints:list1});//waypoints表示途经点
    },
    newArr(arr){
      for(var i=0;i<arr.length;i++){
        for(var j=i+1;j<arr.length;j++){
          if(arr[i].lng==arr[j].lng&&arr[i].lat==arr[j].lat){
          //如果第一个等于第二个，splice方法删除第二个
          arr.splice(j,1);
            j--;
          }
        }
      }
      return arr;
    },
    handleInfo(row){
      this.elderlyData=row
      this.getlocatiom();
    },
    getDeviceSearch(){
      if(this.verify()){
        this.getDevice()
      }
    },
    getDevice(){
      var token =JSON.parse(getToken());
      if(token.visualAccountComadmCommunityCodeList.length>0){
        if(token.visualAccountComadmCommunityCodeList[0] === "getAll"){
          this.plateFormList.push("comadm");
        }else {
          token.visualAccountComadmCommunityCodeList.forEach(ele=>{
            this.govermentCodeList.push(ele);
          })
        }
      }
      if(token.visualAccountHomeGovernmentCodeList.length>0){
        if(token.visualAccountHomeGovernmentCodeList[0] === "getAll"){
          this.plateFormList.push("home");
        }else {
          token.visualAccountHomeGovernmentCodeList.forEach(ele=>{
            this.govermentCodeList.push(ele);
          })
        }
      }
      if(token.visualAccountInsGovernmentCodeList.length>0){
        if(token.visualAccountInsGovernmentCodeList[0] === "getAll"){
          this.plateFormList.push("institution");
        }else {
          token.visualAccountInsGovernmentCodeList.forEach(ele=>{
            this.govermentCodeList.push(ele);
          })
        }
      }
      if(token.visualAccountShopGovernmentCodeList.length>0){
        if(token.visualAccountShopGovernmentCodeList[0] === "getAll"){
          this.plateFormList.push("shop");
        }else {
          token.visualAccountShopGovernmentCodeList.forEach(ele=>{
            this.govermentCodeList.push(ele);
          })
        }
      }
      this.$axios({
          method: 'post',
          url: this.$deviceUrl+'UserDevice/Page',
          data: {
              timeStr:timeStr,
              sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
              name:this.name,
              phone:this.phone,
              idCard:this.idCard,
              govermentCodeList: this.govermentCodeList,
              plateFormList: this.plateFormList,
          }
      }).then( (response)=> {
          if(response.data.error == 0){
            this.dataList=response.data.data
          }else if(response.data.error == 1){
            this.$message({type: 'error', message: response.data.message});
          }
      })
    },
    getTrack(){
      if(!this.elderlyData){
        this.$message.error('请选择所需定位老人')
        return
      }
      if(!this.startTime || !this.endTime){
        this.$message.error('请选择运动轨迹时间段')
        return;
      }
      this.$axios({
          method: 'post',
          url: this.$deviceUrl+'Positioning/MotionCurve',
          data: {
              timeStr:timeStr,
              sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
              userCode:this.elderlyData.userCode,
              startTime:this.startTime,
              endTime:this.endTime
          }
      }).then( (response)=> {
          if(response.data.error == 0){
            var locationList=response.data.data
            if(locationList.length==0){
              this.$message({type: 'error', message:'暂无运动轨迹'});
            }else{
              this.flash=true
              this.location=null
              for(var i in locationList){
                this.locationList[i]=this.qqMapTransBMap(locationList[i].lng,locationList[i].lat)
              }
              this.luxian(this.locationList)
              this.map={
                center:this.locationList[0],
                zoom:17
              }
            }
          }else if(response.data.error == 1){
            this.$message({type: 'error', message: response.data.message});
          }
      })
    },
    verify(){
      if(!this.name&&!this.phone&&!this.idCard){
        this.$message.error('请填写查询条件')
        return false;
      }
      return true
    },
    getlocatiom(){
      if(!this.elderlyData){
        this.$message.error('请选择所需定位老人')
        return
      }
      const loading = this.$loading({
        lock: true,
        text: '定位中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      this.$axios({
          method: 'post',
          url: this.$deviceUrl+'Positioning/PositioningForElderly',
          data: {
              timeStr:timeStr,
              sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
              userCode:this.elderlyData.userCode
          }
      }).then( (response)=> {
          loading.close();
          if(response.data.error == 0){
            this.pollNum=0
            var data=response.data.data
            this.flash=false
            this.location=this.qqMapTransBMap(data.Lon,data.Lat)
            this.locationList=[]
            this.map={
              center:this.location,
              zoom:14
            }
          }else if(response.data.error == 1){
            this.$message({type: 'error', message: response.data.message});
          }
      })
    },
    qqMapTransBMap(lng, lat) {
      // let x_pi = 3.14159265358979324 * 3000.0 / 180.0;
      // let x = lng;
      // let y = lat;
      // let z = Math.sqrt(x * x + y * y) + 0.00002 * Math.sin(y * x_pi);
      // let theta = Math.atan2(y, x) + 0.000003 * Math.cos(x * x_pi);
      // let lngs = z * Math.cos(theta) + 0.0065;
      // let lats = z * Math.sin(theta) + 0.006;

      return {
        lng: lng,
        lat: lat
      }
    },
    reset () {
      this.play=!this.play
    },
    reset1(){
      this.play=false
    },
  }
}


</script>

<style lang="scss" scoped>
.location-container {
  width: 100%;
  height: 100vh;
  margin-top: -75px;
  background-image: url(./img/background.jpg);
  background-size: cover;
  -webkit-background-size: cover;
  -o-background-size: cover;
  background-position: center top;
  min-width: 1360px;
  min-height: 736px;
  .content {
    height: 100%;
    margin: 0;
    padding: 0;
    // margin-top: 80px;
    padding: 0 2.6vw;
    padding-top: 90px;
  }

  .contents {
    min-width: 1220px;
    height: 100%;
      .box-card{
        height: 82.3vh;
        border-color: turquoise;
        border-radius:10px;
        background:rgba(1,25,81,0.9);
        box-sizing: border-box;
        box-shadow:inset 0px 0px 25px 3px rgb(8, 65, 170);
        /deep/ .el-card__header{
          border-color: turquoise;
        }
        .clearfix{
          color: turquoise;
        }
        .search{
          margin-bottom: 10px;
        }
        /deep/ .el-form--inline .el-form-item__label {
          color: turquoise;
        }
      }
      .top{
        // font-size: 40px;
        display: flex;
        margin-bottom: 10px;
        /deep/ .lable{
          color:rgba(28, 252, 255, 1);
        }
        /deep/ .connector{
          color:rgba(28, 252, 255, 1);
        }
      }

      /deep/ .el-table {
            background-color:transparent;
        }
        .el-table::before {
            height: 0px;
        }
        /deep/ .el-table th {
            background-color:transparent;
        }
        /deep/ .el-table__row td{
            border: none;
        }
        /deep/ .el-table__header tr {
          background-image: linear-gradient(to right,rgba(1, 125, 252, 1),rgba(5, 140, 255, 0.01));
          background-color: transparent;
        }
          /deep/ .el-table__body .el-table__row{
              background-color: transparent;
              transition: all .3s;
        }
          /deep/ .el-table__body .el-table__row--striped{
              background-color: rgba(2, 52, 126, 1);
        }
          /deep/ .el-table__body .el-table__row--striped td{
              background-color:transparent;
        }
        /deep/ .el-table th.is-leaf {
          border: 0;
        }
        /deep/ .el-table__header .cell {
            color: rgba(28, 252, 255, 1);
        }
        /deep/ .el-table td div {
            color: rgba(161, 212, 255, 1);
        }
        /deep/  .el-table__body{
            width: 100% !important;
        }
        /deep/ .el-table__header .gutter{
            display: none !important;
        }
        /deep/ .el-table tbody tr:hover>td {
            background-color:transparent!important
        }
        /deep/  .el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar {width: 2px;}
        /deep/  .el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar-thumb {
            border-radius: 10px;
            display: none;
            background: #00FFFF;
        }
        /deep/ .el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar-track {
            border-radius: 0;
            background: transparent;
        }
      /deep/ .el-date-editor {
        .el-range__icon{
          color: rgba(0, 236, 252, 1);
        }
        .el-range__close-icon{
          color: rgba(0, 236, 252, 1);
        }
        .el-range-separator{
          color: rgba(0, 236, 252, 1);
        }
      }

      /deep/ .el-range-editor .el-range-input {
          line-height: 1;
          background: transparent;
          color: rgba(0, 236, 252, 1);
      }
      /deep/ .el-range-editor.el-input__inner {
        background: transparent;
        border-color: rgba(0, 236, 252, 1);
        color: rgba(0, 236, 252, 1);
      }
      /deep/.el-input__icon {
          color: rgba(0, 236, 252, 1);
      }
      /deep/ .el-input__inner {
        background: transparent;
        border: 1px solid rgba(0, 236, 252, 1);
        color: rgba(0, 236, 252, 1);
      }
      ::-webkit-input-placeholder { /* WebKit browsers */
        color: rgba(0, 236, 252, 1);
      }

      ::-moz-placeholder { /* Mozilla Firefox 19+ */
        color: rgba(0, 236, 252, 1);
      }

      :-ms-input-placeholder { /* Internet Explorer 10+ */
        color: rgba(0, 236, 252, 1);
      }
      .serviceMap{
        border-radius:10px;
        height: 77vh;
        overflow: hidden;
        min-height: 500px;
        border: 1px rgba(9, 101, 237, 1) solid;
        position: relative;
        .play{
          position: absolute;
          top:38%;
          left:47%;
          font-size: 80px;
          color: rgba(0, 236, 252, 1);
          z-index: 2000;
        }
        .elderlyInfo{
          position: absolute;
          font-size:40px;
          color: rgba(0, 236, 252, 1);
          width: 100%;
          padding: 20px;
          height: 60px;
          z-index: 2000;
          background: rgba(9, 101, 237, 0.5);
        }
      }
      .leftBox{
        height: 85vh;
        min-height: 625px;
        width: 100%;
        position: relative;
        img{
          position: absolute;
          width: 100%;
          height: 100%;
        }
        .leftBoxInfo{
          width: 100%;
          position: relative;
          padding-top: 5vh;
          .title{
            width: 100%;
            text-align: center;
            font-size:28px;
            font-weight:400;
            color:rgba(0,236,252,1);
            line-height:49px;
            img{
              width: 70%;
              height: 18px;
              margin-left: 15%;
              display: block;
              transform: translate(0,-10px);
            }
          }

        }
      }
    .left{
      border: 1px solid yellow;
      width: 100%;
      height: 85vh;
      min-height: 625px;
    }
    .right{
      border: 1px solid yellow;
      width: 100%;
      height: 85vh;
      min-height: 625px;
    }




  }
}

</style>
